module.exports = __webpack_public_path__ + "img/app_icon_mianju.7421c946.png";